// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendationsCard-cls1_auF","cls2":"RecommendationsCard-cls2_rOu RecommendationsCard-cls1_auF","altLook":"RecommendationsCard-altLook_W7-"};